import { AnimatePresence, motion } from "framer-motion";
import { graphql } from "gatsby";
import React, { FC, useState } from "react";

import { useHeaderMenu } from "../../../../hooks/use-header-menu";
import { Cta } from "../../../buttons/cta";
import { PaginationIndicator } from "../../../pagination/pagination-indicator";
import { PaginationIndicatorColor } from "../../../pagination/pagination-indicator/types";
import { HeaderMenuCard } from "./header-menu-card";

export interface HeaderMenuCardsProps {
  className?: string;
}

export const HeaderMenuCards: FC<HeaderMenuCardsProps> = ({ className }) => {
  const { expandedTab } = useHeaderMenu();
  const slides = expandedTab?.cards ?? [];

  const [slideIndex, setSlideIndex] = useState(0);
  const currentSlide = slides[slideIndex];

  return (
    <div className={className}>
      <AnimatePresence initial={false} mode="popLayout">
        {currentSlide && (
          <motion.div
            className="w-fit max-h-80 aspect-[16/9]"
            key={slideIndex}
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            exit={{
              opacity: 0,
            }}
            transition={{
              opacity: { ease: "easeOut", duration: 0.5 },
            }}
          >
            {currentSlide.cta ? (
              <Cta {...currentSlide.cta}>
                <HeaderMenuCard {...currentSlide} />
              </Cta>
            ) : (
              <HeaderMenuCard {...currentSlide} />
            )}
            {slides.length > 1 && (
              <PaginationIndicator
                align="left"
                className="mt-2 px-2"
                color={PaginationIndicatorColor.Dark}
                totalItems={slides.length}
                activeItem={slideIndex}
                onClickItem={setSlideIndex}
              />
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export const query = graphql`
  fragment HeaderMenuCardData on ContentfulHeaderMenuCard {
    title
    tag
    body {
      raw
    }
    cta {
      ...CtaData
    }
    image {
      gatsbyImageData(layout: CONSTRAINED)
    }
  }
`;
